module.exports = __webpack_public_path__ + "fa-solid-900.605ed7926cf39a2ad5ec.ttf";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/webfonts/fa-solid-900.ttf
// module id = ../../../../../src/assets/fonts/webfonts/fa-solid-900.ttf
// module chunks = styles